import { createApp } from 'vue';
import i18n from './i18n'
import App from './App.vue';
import  store  from  "./store";
import globalFunction from "./modules/GlobaleFuction"
import globalFunctionPrePanier from "./modules/GlobaleFuctionPrePanier"
import VueCryptojs from 'vue-cryptojs'


//Vant
import * as vantComponent from 'vant';
import { Locale } from 'vant';
import 'vant/lib/index.css';
import frFr from 'vant/es/locale/lang/fr-FR';
//import enEn from 'vant/es/locale/lang/en-US';

//Image preview
import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'

Locale.use('fr-FR', frFr);
//Locale.use('en-EN', enEn);

const myApp = createApp(App);

myApp.use(VueCryptojs);

myApp.use(store);

myApp.use(VueViewer)

myApp.use(vantComponent);

myApp.config.globalProperties.globalFunction = globalFunction
myApp.config.globalProperties.globalFunctionPrePanier = globalFunctionPrePanier

myApp.use(i18n);

myApp.mount('#app')